class e extends Error {
  constructor(r) {
    super(r), this.redirect = r;
  }
}
export {
  e as UnauthorizedResponse
};
